export default "__VITE_ASSET__DddZkHVn__"